// Mock Data for Dermatology Category

const baseProducts = [
    {
        id: "med-derm-1",
        name: "Isotretinoin 20mg",
        genericName: "Brand: Accutane",
        indication: "Severe Acne",
        price: "$54",
        originalPrice: "$400",
        savings: "86%",
        description: "A powerful oral medication used to treat severe, nodular acne that has not responded to other treatments, including antibiotics.",
        dosage: "Taken orally, usually once or twice a day with food. Must be taken exactly as prescribed.",
        packaging: "Contains 30 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from light and moisture.",
        sideEffects: "Dry skin, chapped lips, dry eyes, or sun sensitivity. Requires strict pregnancy prevention.",
        category: "Acne Treatments"
    },
    {
        id: "med-derm-2",
        name: "Ustekinumab 45mg",
        genericName: "Brand: Stelara",
        indication: "Psoriasis",
        price: "$1,740",
        originalPrice: "$5,800",
        savings: "70%",
        description: "A biologic medication used to treat moderate to severe plaque psoriasis by targeting specific proteins in the immune system.",
        dosage: "Administered as a subcutaneous injection.",
        packaging: "Contains 1 Pre-filled Syringe",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated between 2°C and 8°C. Do not freeze or shake.",
        sideEffects: "Injection site reactions, upper respiratory infections, or headache.",
        category: "Biologics for Psoriasis"
    },
    {
        id: "med-derm-3",
        name: "Apremilast 30mg",
        genericName: "Brand: Otezla",
        indication: "Psoriatic Arthritis/Psoriasis",
        price: "$560",
        originalPrice: "$3,800",
        savings: "85%",
        description: "An oral systemic treatment for adults with active psoriatic arthritis or moderate to severe plaque psoriasis.",
        dosage: "Taken twice daily, with or without food. Requires an initial dose titration.",
        packaging: "Contains 60 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a dry place.",
        sideEffects: "Diarrhea, nausea, upper respiratory tract infection, or tension headache.",
        category: "Systemic Treatments"
    },
    {
        id: "med-derm-4",
        name: "Secukinumab 150mg",
        genericName: "Brand: Cosentyx",
        indication: "Psoriasis",
        price: "$1,560",
        originalPrice: "$6,800",
        savings: "77%",
        description: "A biologic injection used to treat adults with moderate to severe plaque psoriasis, psoriatic arthritis, and ankylosing spondylitis.",
        dosage: "Injected subcutaneously. Dosing schedule varies by condition.",
        packaging: "Contains 1 Pre-filled Pen/Syringe",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated at 2°C to 8°C. Protect from light.",
        sideEffects: "Cold symptoms, diarrhea, or upper respiratory tract infections.",
        category: "Biologics for Psoriasis"
    },
    {
        id: "med-derm-5",
        name: "Dupilumab 200mg",
        genericName: "Brand: Dupixent",
        indication: "Atopic Dermatitis",
        price: "$1,040",
        originalPrice: "$4,000",
        savings: "74%",
        description: "A targeted biologic therapy used to treat moderate-to-severe atopic dermatitis (eczema) that is not well controlled with prescription therapies used on the skin.",
        dosage: "Administered as a subcutaneous injection, typically every other week.",
        packaging: "Contains 2 Pre-filled Syringes",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated between 2°C and 8°C. Do not expose to heat.",
        sideEffects: "Injection site reactions, conjunctivitis (pink eye), or oral herpes.",
        category: "Biologics for Eczema"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-derm-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Dermatology and Skin Care Solutions",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of severe skin conditions including psoriasis, eczema, and severe acne. Sourced from WHO-GMP certified facilities.`,
            dosage: "Strictly as prescribed by your dermatologist.",
            packaging: "Contains 30 Tablets/Capsules/Ointments",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific side effects. Regular monitoring is essential for systemic treatments.",
            category: "General Dermatological Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const dermatologyProducts = [...baseProducts, ...generateAlphabetMeds()];

export const dermatologyHeroData = {
    title: "Dermatology",
    subtitle: "Psoriasis, eczema, and chronic skin condition treatments",
    description: "Gain access to advanced dermatological treatments, including highly effective biologics for psoriasis and eczema, as well as systemic acne therapies, all at up to 86% savings.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "80%", label: "Average Savings" }
    ]
};

export const dermatologyCategories = [
    "All Categories",
    "Biologics for Psoriasis",
    "Biologics for Eczema",
    "Systemic Treatments",
    "Acne Treatments",
    "General Dermatological Care"
];

export const dermatologyTrustBadges = [
    { text: "WHO-GMP Certified", icon: "ShieldCheck" },
    { text: "Secure Cold-Chain", icon: "Thermometer" },
    { text: "Expert Consultation", icon: "UserCheck" },
    { text: "Authentic Sourcing", icon: "Award" }
];

export const dermatologyFAQs = [
    {
        question: "Do I need a prescription to order dermatology biologics?",
        answer: "Yes. All our targeted therapies, biologics, and systemic dermatology medications require a valid prescription from your treating dermatologist."
    },
    {
        question: "How are biologic injections like Dupixent or Stelara shipped?",
        answer: "These temperature-sensitive medications are shipped via specialized cold-chain logistics using EPS medical-grade coolers and data loggers to guarantee they stay between 2°C and 8°C from dispatch to your door."
    },
    {
        question: "Are generic versions of oral dermatology meds reliable?",
        answer: "Absolutely. Oral medications like generic Isotretinoin and Apremilast are bioequivalent to their brand-name counterparts, ensuring you get the exact clinical outcome safely and affordably."
    },
    {
        question: "Can I get long-term supplies for chronic conditions?",
        answer: "Yes, we specialize in multi-month care plans for chronic conditions like psoriasis and severe eczema, significantly reducing the burden of frequent pharmaceutical refills."
    }
];

export const dermatologyTestimonials = [
    {
        name: "Sarah M.",
        country: "United States",
        savings: "$48,000 annually",
        condition: "Severe Plaque Psoriasis",
        medication: "Secukinumab (Cosentyx Generic)",
        text: "The cost of biologics in the US was completely out of reach. Ordering through this platform cleared my skin entirely and saved me from medical debt. The thermal shipping is incredibly reliable."
    },
    {
        name: "James T.",
        country: "Canada",
        savings: "$35,000 annually",
        condition: "Atopic Dermatitis",
        medication: "Dupilumab (Dupixent Generic)",
        text: "Eczema ruled my life until I accessed affordable Dupilumab here. The process was transparent, the team is supportive, and the medication arrived icy cold and perfect."
    },
    {
        name: "Amanda K.",
        country: "Australia",
        savings: "$4,000 annually",
        condition: "Nodular Acne",
        medication: "Isotretinoin",
        text: "I was able to afford a full course of generic Accutane. The quality was identical to the expensive brand name, and the customer service during international shipping was excellent."
    }
];

export const dermatologySectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Read how patients have restored their skin health and confidence through access to affordable specialty care."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Vital information about safely ordering advanced dermatology treatments."
    },
    midPageCTA: {
        title: "Looking for a Specific Skin Treatment?",
        description: "Our procurement team can source a wide array of dermatological biologics and systemic medications globally. Contact us for a quote.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Treatment Cost"
    },
    finalCTA: {
        title: "Reclaim Your Skin Health Today",
        description: "Don't let exorbitant drug prices keep you from the relief you deserve. Secure your affordable treatment securely.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
